/* eslint-disable react/prop-types */
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        if (import.meta.env?.DEV) {
            // eslint-disable-next-line no-console
            console.error("ErrorBoundary caught:", error, errorInfo);
        }
        // TODO: forward to Sentry / your error tracker here in production.
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
                    <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg text-center">
                        <div className="text-red-500 mx-auto w-16 h-16 mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                            </svg>
                        </div>

                        <h1 className="text-2xl font-bold text-gray-800 mb-2">Unexpected Application Error</h1>
                        <p className="text-gray-600 mb-6">
                            Something went wrong on this page. Please reload, or head back and try again. If it keeps happening, contact support.
                        </p>

                        <div className="space-y-3">
                            <button
                                onClick={this.handleReset}
                                className="w-full py-3 px-4 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition duration-200"
                            >
                                Reload Application
                            </button>
                            <button
                                onClick={() => window.history.back()}
                                className="w-full py-3 px-4 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition duration-200"
                            >
                                Go Back
                            </button>
                        </div>

                        {import.meta.env?.DEV && this.state.error?.stack && (
                            <div className="mt-8 text-left bg-gray-50 p-4 rounded-lg">
                                <h3 className="font-medium text-gray-700 mb-2">Error Details (dev only):</h3>
                                <code className="text-xs text-red-500 block whitespace-pre overflow-x-auto">
                                    {this.state.error.stack}
                                </code>
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;